import React from "react";

//styles
import "./styles/main.css";
import "./styles/core/containers.css";
import "./styles/core/buttons.css";  
import styled from "styled-components";

//Components
import NavBar from "../components/navBar";
import Footer from "../components/footer";

const LayoutWrapper = styled.div`
  margin-top: 100px;
`;

const Layout = ({ children }) => {
  return (
    <LayoutWrapper>
      <NavBar/>
      <main>{children}</main>
      <Footer/>
    </LayoutWrapper>
  );
};

export default Layout;